import React from 'react'
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router-dom'

import './style.css'

class Services extends React.PureComponent {
  render() {
    const {
      treatments,
      conditions,
    } = this.props.data

    return (
      <div className="services">
        <div className="container">
          <h1 className="title">Treatments</h1>
          <div className="list-wrapper">
            <List>
              {Object.keys(treatments).map((key, index) => {
                const treatment = treatments[key]

                return (
                  <Link to={`/treatments/${key}`} key={index}>
                    <ListItem
                      primaryText={treatment.name}
                    />
                  </Link>
                )
              })}
            </List>
          </div>
          <h1 className="title">Conditions</h1>
          <div className="list-wrapper">
            {Object.keys(conditions).map((subkey, index) => {
              const category = conditions[subkey]

              return (
                <List key={index}>
                  {index > 0 &&
                    <Divider />
                  }
                  <Subheader>{category.name}</Subheader>
                  {Object.keys(category.child).map((key, index) => {
                    const condition = category.child[key]

                    return (
                      <Link to={`/conditions/${subkey}/${key}`} key={index}>
                        <ListItem
                          primaryText={condition.name}
                        />
                      </Link>
                    )
                  })}
                </List>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default Services



// WEBPACK FOOTER //
// ./src/components/Services/index.js